import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useRef, useEffect } from 'react';
import { useSliderContext } from '../../../utils/sliderContext';
export var useAutoScroll = function useAutoScroll() {
  var _useSliderContext = useSliderContext(),
      scrollNext = _useSliderContext.scrollNext,
      currentSlide = _useSliderContext.currentSlide,
      totalSlides = _useSliderContext.totalSlides,
      isActive = _useSliderContext.autoScroll,
      _useSliderContext$aut = _useSliderContext.autoScrollSettings,
      autoScrollSettings = _useSliderContext$aut === void 0 ? {} : _useSliderContext$aut;

  var _autoScrollSettings$i = autoScrollSettings.interval,
      interval = _autoScrollSettings$i === void 0 ? 1000 : _autoScrollSettings$i;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  var lastAutoscrollSlide = useRef(currentSlide); // Запускает таймер с автопрокрутой слайдов

  useEffect(function () {
    if (!isActive) {
      return function () {};
    }

    var scrollTimer = setInterval(function () {
      scrollNext();
      lastAutoscrollSlide.current += 1;
    }, interval);
    setTimer(scrollTimer);
    return function () {
      return clearInterval(scrollTimer);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]); // Останавливает таймер с автопрокруткой слайдов по условиям

  useEffect(function () {
    if (!timer) {
      return;
    }

    var isLastSlide = currentSlide === totalSlides - 1;
    /**
     * Флаг означает, что пользователь вручную прокрутил слайд
     *
     * Вычисляем с помощью сравнения счетчика слайдов, которые были прокручены автоматически lastAutoscrollSlide
     * с текущим счетчиком слайдов currentSlide
     */

    var isStoppedByUser = currentSlide > 0 && currentSlide !== lastAutoscrollSlide.current;

    if (!isActive || isLastSlide || isStoppedByUser) {
      clearInterval(timer);
      setTimer(null);
    }
  }, [currentSlide, isActive, scrollNext, timer, totalSlides]);
  useEffect(function () {
    return function () {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [timer]);
};